import { Component, Input } from '@angular/core';

@Component({
  selector: 'om-error-list-banner',
  templateUrl: './error-list-banner.component.html',
  styleUrls: ['./error-list-banner.component.scss', '../inline-editable.scss'],
})
export class ErrorListBannerComponent {
  @Input() heading = 'Please correct the following:';
  @Input() errors: { message: string; href: string }[] = [];
  constructor() {}
}
